window.dataLayer = window.dataLayer || [];

(function () {
  if (window.__gtmTrackingInitialized) {
    console.log("[GTM Tracking] already initialized, aborting");
    return;
  }
  window.__gtmTrackingInitialized = true;

  const DL = window.dataLayer;
  const DEBUG = true;

  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ["[GTM Tracking]"].concat(Array.from(arguments)));
  }

  function makeEventId(prefix) {
    return prefix + "_" + Date.now() + "_" + Math.floor(Math.random() * 1000000000);
  }

  function safeNumber(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  function getShopCurrency() {
    return (
      window.Shopify?.currency?.active ||
      window.Shopify?.currency?.current ||
      document.documentElement.getAttribute("data-currency") ||
      "USD"
    );
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      log("JSON parse failed", e, value);
      return null;
    }
  }

  function normalizeProduct(raw) {
    if (!raw) return null;

    const itemId = raw.item_id || raw.variant_id || raw.id;
    if (!itemId) return null;

    const price = safeNumber(raw.price, 0);
    const quantity = safeNumber(raw.quantity, 1);

    return {
      item_id: String(itemId),
      item_name: raw.item_name || raw.product_title || raw.title || "",
      item_brand: raw.item_brand || raw.vendor || "",
      item_category: raw.item_category || raw.product_type || "",
      item_variant: raw.item_variant || raw.variant_title || "",
      price: price,
      quantity: quantity
    };
  }

  function buildEcommerceFromProduct(rawProduct) {
    const item = normalizeProduct(rawProduct);
    if (!item) return null;

    return {
      currency: rawProduct.currency || getShopCurrency(),
      value: safeNumber(item.price * item.quantity, 0),
      items: [item]
    };
  }

  function pushEcommerceEvent(eventName, ecommerce, prefix) {
    if (!eventName || !ecommerce || !Array.isArray(ecommerce.items) || !ecommerce.items.length) {
      log("Skipped push due to invalid ecommerce payload", eventName, ecommerce);
      return;
    }

    const payload = {
      event: eventName,
      event_id: makeEventId(prefix),
      ecommerce: ecommerce
    };

    DL.push({ ecommerce: null });
    DL.push(payload);

    log("Pushed event", payload);
  }

  function handleViewItem() {
    const el = document.getElementById("gtm-product-data");
    if (!el) {
      log("No #gtm-product-data found, skipping view_item");
      return;
    }

    let productData;
    try {
      productData = JSON.parse(el.textContent);
    } catch (e) {
      log("Failed to parse #gtm-product-data", e);
      return;
    }

    const ecommerce = buildEcommerceFromProduct(productData);
    if (!ecommerce) {
      log("Invalid product data for view_item", productData);
      return;
    }

    pushEcommerceEvent("view_item", ecommerce, "vi");
  }

  function getProductDataFromPdpForm(form) {
    if (!form) return null;

    const taggedEl = form.querySelector("[data-gtm-product]");
    if (taggedEl) {
      const taggedData = parseJson(taggedEl.getAttribute("data-gtm-product"));
      if (taggedData) return taggedData;
    }

    const pageEl = document.getElementById("gtm-product-data");
    if (pageEl) {
      try {
        const pageData = JSON.parse(pageEl.textContent);
        if (pageData) {
          return {
            item_id: pageData.item_id || pageData.variant_id || pageData.id,
            item_name: pageData.item_name || pageData.product_title || pageData.title,
            item_brand: pageData.item_brand || pageData.vendor,
            item_category: pageData.item_category || pageData.product_type,
            item_variant: pageData.item_variant || pageData.variant_title,
            price: safeNumber(pageData.price, 0),
            quantity: 1,
            currency: pageData.currency || getShopCurrency()
          };
        }
      } catch (e) {
        log("Fallback PDP product data parse failed", e);
      }
    }

    return null;
  }

  let lastAtcKey = null;
  let lastAtcTime = 0;

  function shouldSkipDuplicate(key, windowMs) {
    const now = Date.now();

    if (lastAtcKey === key && now - lastAtcTime < windowMs) {
      log("Skipped duplicate add_to_cart", key);
      return true;
    }

    lastAtcKey = key;
    lastAtcTime = now;
    return false;
  }

  function buildAtcKey(source, productData, context) {
    return [
      source,
      context || window.location.pathname,
      String(productData?.item_id || ""),
      String(safeNumber(productData?.quantity || 1, 1)),
      String(safeNumber(productData?.price || 0, 0))
    ].join("|");
  }

  function isQuickBuyElement(el) {
    return !!el.closest("quick-add-to-cart");
  }

  function handleQuickBuyClick(event) {
    console.log("QUICK BUY CLICK TRACKED", button);
    const button = event.target.closest(
      'button[data-gtm-quick-add][data-gtm-product][type="submit"], button[data-gtm-product][type="submit"]'
    );

    if (!button) return;
    if (!isQuickBuyElement(button)) return;

    const productData = parseJson(button.getAttribute("data-gtm-product"));
    if (!productData) {
      log("No valid product data on quick-buy button");
      return;
    }

    const productRoot =
      button.closest("[data-product-id]") ||
      button.closest("[data-product-handle]") ||
      button.closest(".product-item") ||
      button.closest(".card-product") ||
      button.closest("quick-add-to-cart");

    const context =
      productRoot?.getAttribute("data-product-id") ||
      productRoot?.getAttribute("data-product-handle") ||
      window.location.pathname;

    const key = buildAtcKey("quickbuy", productData, context);

    if (shouldSkipDuplicate(key, 2500)) {
      return;
    }

    const ecommerce = buildEcommerceFromProduct(productData);
    if (!ecommerce) {
      log("Invalid quick-buy ecommerce payload", productData);
      return;
    }

    pushEcommerceEvent("add_to_cart", ecommerce, "atc");
  }

  function handlePdpFormSubmit(event) {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    if (isQuickBuyElement(form)) {
      return;
    }

    const productData = getProductDataFromPdpForm(form);
    if (!productData) {
      log("No valid product data found for PDP cart form");
      return;
    }

    const qtyInput = form.querySelector('input[name="quantity"]');
    if (qtyInput) {
      productData.quantity = safeNumber(qtyInput.value, productData.quantity || 1);
    }

    const key = buildAtcKey("pdp", productData, window.location.pathname);

    if (shouldSkipDuplicate(key, 1500)) {
      return;
    }

    const ecommerce = buildEcommerceFromProduct(productData);
    if (!ecommerce) {
      log("Invalid PDP ecommerce payload", productData);
      return;
    }

    pushEcommerceEvent("add_to_cart", ecommerce, "atc");
  }

  function initAddToCartTracking() {
    document.addEventListener("click", handleQuickBuyClick, true);
    document.addEventListener("submit", handlePdpFormSubmit, true);
    log("Initialized split add_to_cart tracking");
  }

  function init() {
    handleViewItem();
    initAddToCartTracking();
    log("Tracking initialized");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();